<template>
  <b-dropdown
    variant="link"
    no-caret
    toggle-class="p-0"
    right
    class="action-dropdown"
  >
    <template #button-content>
      <div id="icon-add" v-if="isAddBtn">
        <icon-add class="icon-add-btn" />
      </div>
      <b-button variant="secondary" class="action-dropdown-kebab" v-else>
        <kebab-icon />
      </b-button>
    </template>
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <div v-for="name in setActionList" :key="name.label">
      <b-dropdown-item
        v-if="name.display"
        @click="resolveAction(name.value, itemData)"
      >
        <div class="d-flex align-items-center">
          <component :is="name.icon" class="mr-1 action-dropdown-svg" />
          <span v-if="!isRadio" class="pl-1">{{ name.label }}</span>
          <b-form-radio
            v-model="radioValue"
            v-if="isRadio"
            :value="name.value"
            class="custom-radio-group"
          >
            <span class="pl-1">{{ name.label }}</span>
          </b-form-radio>
        </div>
      </b-dropdown-item>
    </div>
  </b-dropdown>
</template>

<script>
import { BButton, BDropdown, BDropdownItem } from "bootstrap-vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import KebabIcon from "@/@core/components/svg/common/Kebeb.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import CopyIcon from "@/@core/components/svg/action-group/IconCopyTo.vue";
import MoveIcon from "@/@core/components/svg/action-group/IconMoveTo.vue";
import ReorderIcon from "@/@core/components/svg/action-group/IconReorder.vue";
import AssignBannerGroupIcon from "@/@core/components/svg/common/FileRightArrow.vue";
import AssignSetBannerIcon from "@/@core/components/svg/action-group/BoxGroup.vue";
import MappingToIcon from "@/@core/components/svg/action-group/IconMappingTo.vue";
import IconTransfer from "@/@core/components/svg/common/IconTransfer.vue";
import IconDetail from "@/@core/components/svg/common/IconDetail.vue";
import IconStockDetail from "@/@core/components/svg/common/IconStockDetail.vue";
import Notification from "@/@core/components/svg/common/Notification.vue";
import IconHistory from "@/@core/components/svg/common/IconHistory.vue";
import IconSettingManage from "@/@core/components/svg/common/IconSettingManage.vue";
import IconImport from "@/@core/components/svg/common/IconImport.vue";
import IconDetail2 from "@/@core/components/svg/common/IconDetail2.vue";
import CopyLinkIcon from "@/@core/components/svg/action-group/IconCopyLink.vue";
import PreviewIcon from "@core/components/svg/action-group/IconPreview.vue";
import DownloadIcon from "@/@core/components/svg/code-template/Download.vue";
import IconPlus from "@core/components/svg/common/IconPlus.vue";
import IconDuplicate from "@/@core/components/svg/common/IconDuplicate.vue";
import IconEdit from "@/@core/components/svg/action-group/IconEdit.vue";
import IconTrash from "@/@core/components/svg/common/IconTrash.vue";
import AddQuestionIcon from "@core/components/svg/survey/IconAddQuestion.vue";
import AddSectionIcon from "@core/components/svg/survey/IconAddSection.vue";
import { reactive } from "@vue/composition-api";
import { props } from "vue-prism-component";
import IconEditWinner from "@/@core/components/svg/common/IconEditWinner.vue";
import IconAdd from "@core/components/svg/survey/IconPlus.vue";

export default {
  components: {
    BDropdown,
    BButton,
    BDropdownItem,
    EditIcon,
    KebabIcon,
    DeleteIcon,
    CopyIcon,
    MoveIcon,
    ReorderIcon,
    AssignBannerGroupIcon,
    AssignSetBannerIcon,
    MappingToIcon,
    IconDetail,
    IconStockDetail,
    IconHistory,
    IconTransfer,
    IconSettingManage,
    IconImport,
    IconDetail2,
    CopyLinkIcon,
    PreviewIcon,
    DownloadIcon,
    Notification,
    IconEditWinner,
    IconPlus,
    IconDuplicate,
    IconEdit,
    IconTrash,
    AddQuestionIcon,
    AddSectionIcon,
    IconAdd,
  },
  props: {
    resolveAction: Function,
    setActionList: Object,
    itemData: Object,
    isRadio: { type: Boolean, default: false },
    radioValue: Number,
    isAddBtn: { type: Boolean, default: false },
    title: { type: String, default: "" },
  },
};
</script>

<style>
.action-dropdown-kebab,
.action-dropdown-kebab:active {
  padding: 0.3rem 0.6rem;
  border: none;
  background: transparent !important;
}

.action-dropdown-kebab:hover {
  box-sizing: border-box;
  border-radius: 0;
  background-color: #eeeeee !important;
}

.action-dropdown > ul.dropdown-menu.show > div > li > a:hover {
  color: #737373 !important;
  font-size: 18px;
  background-color: rgba(115, 115, 115, 0.1) !important;
  font-weight: unset;
}

.action-dropdown > ul.dropdown-menu.show > div > li > a {
  font-size: 18px;
}

.action-dropdown > ul.dropdown-menu.show > li > a:focus,
.action-dropdown > ul.dropdown-menu.show > li > a:active {
  color: white !important;
  background-color: var(--primary) !important;
}
.action-dropdown > ul.dropdown-menu.show > li > a:focus > div > svg > path,
.action-dropdown > ul.dropdown-menu.show > li > a:active > div > svg > path {
  fill: white !important;
}

.action-dropdown .dropdown-item {
  padding: 0.3em 1.28rem;
}

.action-dropdown .dropdown-menu {
  border-radius: 0.958rem !important;
}

.action-dropdown-svg {
  width: 20px;
  fill: #737373;
}

.custom-radio-group
  input.custom-control-input:active
  ~ .custom-control-label::after,
.custom-radio-group
  input.custom-control-input:checked
  ~ .custom-control-label::after {
  background-color: #34be49;
  border-radius: 50%;
  border: 2.5px solid #ffffff;
  box-shadow: 0 0 0 1px #34be49;
}

#icon-add .icon-add-btn {
  top: -4px;
  position: relative;
  width: 40px;
}

.title {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 5px;
}
</style>
